export default __webpack_public_path__ + "static/IMG_1787-fd11a736419d9720a3e7e431352b2d2c.jpg";